:host > span {
  position: relative;
  background-color: var(--aha-pill--bg-color, var(--theme-primary-background));
  color: var(--aha-pill--fg-color, var(--theme-primary-text));
  display: inline-block;
  padding: 0.1em 0.5em;
  border-radius: 4px;
  line-height: 1.5;
  box-shadow: var(--aha-pill--box-shadow);
}

:host([border-shape='round']) > span {
  border-radius: var(--aha-pill--border-radius, 12px);
  padding-left: 0.75em;
  padding-right: 0.75em;
}

:host([size='mini']) {
  font-size: 8px;
  line-height: 1;
}

:host([size='small']) > span {
  padding-top: 0;
  padding-bottom: 0;
  line-height: var(--default-line-height);
}

:host([type='outline']) > span {
  border: 1px solid var(--aha-pill--border-color);
}

aha-icon {
  margin-left: 0.5em;
  font-size: 85%;
}
